const track = (event, eventDetails) => {
  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({...eventDetails, event});
}

/**
 * Tracks preselections for MC subscriptions
 * 
 * @param {{
 *   initial: boolean,
 *   amount: number,
 *   amount_cents: number,
 *   week: string,
 *   time_slot_id: number,
 *   delivery_date: string,
 *   meals_array: Array<{
 *     sku: string,
 *     image: string,
 *     price: number,
 *     price_cents: number,
 *     quantity: number,
 *     name: string,
 *   }>,
 * }} data 
 */
export const trackPreselections = (data) => {
  track('bold_mc_customer_preselection', data);
}